import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'set',
  name: 'Edit Fields (Set)',
  category: 'utilities',
  description: 'Add, remove, or modify fields in your data items',
  icon: 'FileEdit',
  color: 'cyan',
  version: '3.4.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'Edit Fields',
    color: '#06b6d4'
  },
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['set', 'edit', 'fields', 'transform', 'map', 'modify'],
  
  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.set/'
  }
};

export default definition;
